import { render, staticRenderFns } from "./PromoItemForm.vue?vue&type=template&id=607f0e16"
import script from "./PromoItemForm.vue?vue&type=script&lang=js"
export * from "./PromoItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports